'use strict';

/* Relevance Engine Factory: 3 things API */


angular.module('storyApp').factory('threeThingsAPI', ['$http', '$q', '$location', 'trackingUtils' ,'storiesFilterService', function($http, $q, $location, trackingUtils ,storiesFilterService) {

    return {

        apiUrl: '',
        isTestApi: false,
        baseUrl: location.origin || location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : ''),

        //hardcode articleApiPath /wp-admin/admin-ajax.php for now. This path needs to be updated for security reason
        threethingQuery: '?threeThings=true',

        //set 3 things API
        setApiUrl: function(apiUrl) {

            var that = this,
                locHref =  location.href;

            that.apiUrl = apiUrl;

            // use 3 things dummy file if url contains 'testapi=true'
            if ( locHref.indexOf('testapi=true' ) > -1 ){
                that.apiUrl = '/wp-content/themes/foxsports/assets/dist/dummy_all.html';
                that.isTestApi = true;
            } else if ( locHref.indexOf('testapivideo=true' ) > -1 ){
                that.apiUrl = '/wp-content/themes/foxsports/assets/dist/dummy_videos.html';
                that.isTestApi = true;
            } else if ( locHref.indexOf('testapigallery=true' ) > -1 ){
                that.apiUrl = '/wp-content/themes/foxsports/assets/dist/dummy_galleries.html';
                that.isTestApi = true;
            }

        },

        getApiUrl: function() {
            return this.apiUrl;
        },
        filterDataFromStorage: function(docsData){
            var that = this;
            if(typeof window.localStorage !== 'undefined') {
                var currentStories = storiesFilterService.getCurrentStories('all',storiesFilterService.storeAllStories(docsData, false, 'parsely'));
                return currentStories;
            }else{
                return docsData;
            }
        },
        getThreeThings: function(apiUrl) {

            var that = this;
            that.setApiUrl(apiUrl);

            var deferred = $q.defer();

            //don't run the filter when using test API, dummy files
            if(!that.isTestApi) {
                apiUrl = storiesFilterService.updateApiLimitCount(that.getApiUrl(), "parsely");
            } else {
                apiUrl = that.getApiUrl();
            }

            $http.jsonp(apiUrl).success(function(data) {

                var response = data.data;

                if (typeof response !== 'undefined' && response.length > 0 ) {

                    if(!that.isTestApi) {
                        data = that.filterDataFromStorage(response).slice(0, 3);
                    } else {
                        data = response.slice(0, 3);
                    }

                    data = response.slice(0, 3);

                    data = that.updateApiResponseUrls(data);

                    deferred.resolve(data);

                }

            }).error(function(msg) {
                deferred.reject(msg);
            });

            return deferred.promise;

        },
        updateApiResponseUrls: function(data){

            var that = this;

            for(var i=0, l=data.length; i<l; i++){
                
                if(typeof data[i].url !== 'undefined') {

                    //get article content from post where it has no header and footer
                    //Ex: http://www.foxsports.com/mlb/story/philadelphia-phillies-jose-bautista-jay-bruce-brandon-moss-free-agency-trades-hot-stove-ken-rosenthal-010317?threeThings=true
                    data[i].articleUrl =  data[i].url + that.threethingQuery;

                    //remove host name for all urls. It won't work in angularJS app if we use absolute urls.
                    data[i].url = data[i].url.replace(/.*?\.(com|dev)/g, '');

                    //if image is returned default image, remove it since we want to use svg for the default image
                    if ( data[i].image_url.match( /default_image/ ) ) {
                        data[i].image_url = '';
                    } else {
                        //replace 1200x675 or 518x518 image with 161x73 thumbnail image
                        data[i].image_url = data[i].image_url.replace(/(1200\.675|518\.518)/g, '161.73');
                    }
                   
                    
                }
            }

            return data;
        }

    }

}]);



// WEBPACK FOOTER //
// ./assets/components/threethings/factories/threeThingsAPI.js